import React from 'react'
import {FileSelectState} from './state'
import {definedContextValueHookFactory} from '@oc/hooks'

const FileSelectContext = React.createContext<FileSelectState | null>(null)

export function FileSelectContextProvider(props: React.PropsWithChildren) {
    const [state] = React.useState(new FileSelectState(window))
    const {children} = props

    return <FileSelectContext.Provider value={state}>{children}</FileSelectContext.Provider>
}

export const useFileSelect = definedContextValueHookFactory(FileSelectContext, 'FileSelectContext')
